import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PAGES = {
  "privacy-policy": {
    title: "Privacy Policy",
    body: [
      "Ultima actualizare: 2026",
      "Această politică explică modul în care Payouts By Ceo colectează, folosește și protejează datele utilizatorilor care accesează website-ul.",
      "Putem colecta date precum adresa de email, date tehnice despre dispozitiv, paginile accesate și interacțiunile cu butoanele de pe site.",
      "Folosim aceste date pentru a îmbunătăți experiența pe website, pentru a trimite update-uri atunci când utilizatorul se abonează și pentru a analiza performanța paginii prin Google Analytics.",
      "Nu vindem datele personale către terți.",
      "Website-ul poate conține link-uri către platforme externe, inclusiv PU Prime, Telegram, Instagram, TikTok, Facebook și YouTube. Nu suntem responsabili pentru politicile de confidențialitate ale acestor platforme.",
      "Prin utilizarea website-ului, ești de acord cu această politică de confidențialitate.",
    ],
  },
  "terms-and-conditions": {
    title: "Terms & Conditions",
    body: [
      "Ultima actualizare: 2026",
      "Prin accesarea acestui website, ești de acord cu termenii și condițiile prezentate mai jos.",
      "Website-ul Payouts By Ceo are scop informativ, educativ și de comunitate. Conținutul publicat nu reprezintă consultanță financiară, recomandare de investiții sau promisiune de profit.",
      "Link-urile către PU Prime pot fi link-uri de afiliere. Dacă îți creezi cont prin aceste link-uri, este posibil să primim un comision, fără cost suplimentar pentru tine.",
      "Utilizatorul este responsabil pentru propriile decizii financiare și pentru verificarea termenilor oficiali ai platformelor externe accesate.",
      "Ne rezervăm dreptul de a modifica website-ul, conținutul sau termenii în orice moment.",
    ],
  },
  "gdpr-cookies": {
    title: "GDPR / Cookies",
    body: [
      "Ultima actualizare: 2026",
      "Acest website poate folosi cookie-uri și tehnologii similare pentru analiză, funcționalitate și măsurarea performanței.",
      "Folosim Google Analytics pentru a înțelege cum este utilizat website-ul și ce interacțiuni au utilizatorii cu pagina.",
      "Datele colectate pot include informații tehnice despre dispozitiv, browser, pagini vizitate și acțiuni realizate pe website.",
      "Dacă introduci adresa de email în formularul de abonare, aceasta va fi folosită pentru a-ți trimite update-uri despre comunitate, challenge-uri și noutăți.",
      "Ai dreptul să soliciți ștergerea sau modificarea datelor tale personale, acolo unde este aplicabil.",
      "Prin folosirea website-ului, accepți utilizarea cookie-urilor conform acestei politici.",
    ],
  },
  "risk-disclaimer": {
    title: "Risk Disclaimer",
    body: [
      "Tradingul implică risc ridicat și poate duce la pierderea capitalului investit.",
      "Informațiile prezentate pe acest website sunt educative și nu reprezintă consultanță financiară, recomandare de investiții sau promisiune de profit.",
      "Performanțele trecute, challenge-urile publice sau exemplele prezentate nu garantează rezultate viitoare.",
      "Nu investi bani pe care nu îți permiți să îi pierzi.",
      "Înainte de a tranzacționa, verifică termenii oficiali ai brokerului și asigură-te că înțelegi riscurile implicate.",
    ],
  },
};

export default function LegalPage({ slug }) {
  const page = PAGES[slug];
  const navigate = useNavigate();
  if (!page) return null;

  const handleBack = () => {
    // Use browser history when available; otherwise fall back to homepage.
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div data-testid={`legal-page-${slug}`} className="min-h-screen bg-white text-black antialiased">
      <div className="max-w-2xl mx-auto px-6 pt-10 pb-16 sm:pt-14">
        <button
          type="button"
          onClick={handleBack}
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.16em] text-black/55 hover:text-black transition"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Înapoi
        </button>
        <h1 className="mt-6 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-black">
          {page.title}
        </h1>
        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-black/75">
          {page.body.map((p) => (
            <p key={p.slice(0, 32)}>{p}</p>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-black/10 text-[12px] text-black/45">
          © Payouts By Ceo
        </div>
      </div>
    </div>
  );
}
